import { Box } from "@mui/material";
import { ReactNode } from "react";
import { configuratorTemplateStyleProps } from "../theme/main";
import { ConfiguratorLayout } from "../theme/types";

type ConfiguratorTemplateProps = {
  viewer: ReactNode;
  optionsMenu: ReactNode;
  navigationMenu: ReactNode;
  layout?: ConfiguratorLayout;
};

export function ConfiguratorTemplate({
  viewer,
  optionsMenu,
  navigationMenu,
  layout = "vertical",
}: ConfiguratorTemplateProps) {
  //
  const { optionsMenuStyle, navigationMenuStyle, ...templateStyle } =
    configuratorTemplateStyleProps;
  const isVertical = layout === "vertical";
  const height = templateStyle.height;
  const width = templateStyle.width;
  const optionsMenuSize = optionsMenuStyle.optionsMenuSize;

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        height: height,
        width: width,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          height: height,
          width: width,
        }}
      >
        {viewer}
      </Box>
      <Box
        sx={{
          ...{
            position: "absolute",
            zIndex: 2,
          },
          ...navigationMenuStyle,
        }}
      >
        {navigationMenu}
      </Box>
      <Box
        sx={{
          position: "absolute",
          zIndex: 1,
          display: "flex",
          flexDirection: isVertical ? "row" : "column",
          top: isVertical ? "auto" : 0,
          bottom: isVertical ? 0 : "auto",
          right: isVertical ? "auto" : 0,
          left: isVertical ? 0 : "auto",
          height: isVertical ? optionsMenuSize : "100%",
          width: isVertical ? "100%" : optionsMenuSize,
        }}
      >
        {optionsMenu}
      </Box>
    </Box>
  );
}
